import {useLazyQuery} from '@apollo/client';
import {ALL_USERS} from './permissionsAuditPageQueries';
import {StaffDetails} from '../../schema-types/StaffDetails';
import {PermGroupsEnum} from '../../schema-types/globalTypes';
import {
  GetAllStaff,
  GetAllStaffVariables,
  GetAllStaff_allStaff,
} from '../../schema-types/GetAllStaff';

const sortStaffAlphabetically = (a: GetAllStaff_allStaff, b: GetAllStaff_allStaff) => {
  const textA = a?.name?.toLowerCase() || '';
  const textB = b?.name?.toLowerCase() || '';
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

export const useAllStaff = () => {
  const [getAllStaff, {data, loading, error: staffError}] = useLazyQuery<
    GetAllStaff,
    GetAllStaffVariables
  >(ALL_USERS);
  return {
    staffList: [...(data?.allStaff || [])].sort(sortStaffAlphabetically),
    loading,
    staffError,
    getAllStaff,
  };
};

export const formatGroupName = (
  name: string | null | undefined
): string | null | undefined => name?.replace(/_/g, ' ').toUpperCase();

export const formatGroupNameAsEnum = (name: string): PermGroupsEnum =>
  name.replace(' ', '_').toLocaleLowerCase() as PermGroupsEnum;

const getFormattedGroupName = (staff: StaffDetails): string | null | undefined =>
  formatGroupName(staff.groups?.[0]?.name);

export function transformStaffData(
  staffArray: StaffDetails[] | null
): Record<string, StaffDetails[]> {
  if (!staffArray) return {};

  return staffArray.reduce<Record<string, StaffDetails[]>>((acc, staff) => {
    const groupName = getFormattedGroupName(staff);
    if (groupName) {
      return {
        ...acc,
        [groupName]: acc[groupName] ? [...acc[groupName], staff] : [staff],
      };
    }
    return acc;
  }, {});
}
